import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { SHOW_LOGIN, SITE } from "./siteConfig";

const NAV_LINKS = [
    { href: "#formats", label: "Форматы" },
    { href: "#constructor", label: "Конструктор" },
    { href: "#examples", label: "Примеры лидов" },
    { href: "#roi", label: "Расчёт выгоды" },
    { href: "#faq", label: "Вопросы" },
];

const Header = () => {
    const [navOpen, setNavOpen] = useState(false);
    const [stuck, setStuck] = useState(false);
    const navRef = useRef(null);

    useEffect(() => {
        const onScroll = () => {
            setStuck(window.scrollY > 40 || navOpen);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, [navOpen]);

    const closeNav = () => setNavOpen(false);

    return (
        <header className={`hdr${stuck ? " is-stuck" : ""}`} id="top">
            <div className="wrap hdr__in">
                <Logo />

                <nav className={`hdr__nav${navOpen ? " is-open" : ""}`} id="nav" ref={navRef}>
                    {NAV_LINKS.map((l) => (
                        <a key={l.href} href={l.href} className="hdr__link" onClick={closeNav}>
                            {l.label}
                        </a>
                    ))}
                </nav>

                {(SITE.phone || SHOW_LOGIN) && (
                    <div className="hdr__side">
                        {SITE.phone && (
                            <a href={`tel:${SITE.phoneLink}`} className="hdr__phone">
                                {SITE.phone}
                            </a>
                        )}
                        {SHOW_LOGIN && (
                            <Link to="/login" className="btn btn--sm hdr__cta">
                                Войти
                            </Link>
                        )}
                    </div>
                )}

                <button
                    className="burger"
                    aria-label="Меню"
                    aria-expanded={navOpen}
                    aria-controls="nav"
                    onClick={() => setNavOpen((v) => !v)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </header>
    );
};

export default Header;
